module.exports = __webpack_public_path__ + "img/content-deleted.95483e2b.svg";